import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-nkf-blue">
        <div className="font-display tracking-widest text-sm">VERIFYING SESSION…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && roles.length && !roles.includes(user.role) && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
